import { Injectable } from '@angular/core';
import { App } from '@capacitor/app';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';

export interface AdminVoucherScannerBackButtonListenerHandle {
  remove: () => Promise<void>;
}

@Injectable({
  providedIn: 'root',
})
export class AdminVoucherScannerBackButtonService {
  /** Scanner listeners added and not removed yet. */
  private activeListeners = 0;

  /**
   * Whether a scanner owns Android Back right now. Capacitor hands a press to
   * every Back listener, so the app's own Back handler (story #11856) stands
   * aside while this is true.
   */
  public hasActiveListener(): boolean {
    return this.activeListeners > 0;
  }

  public addListener(
    listener: () => void,
  ): Promise<AdminVoucherScannerBackButtonListenerHandle | null> {
    if (
      !Capacitor.isNativePlatform() ||
      Capacitor.getPlatform() !== 'android'
    ) {
      return Promise.resolve(null);
    }

    this.activeListeners++;
    return this.addNativeListener(() => {
      listener();
    }).then(
      (handle) => ({
        remove: () => {
          this.activeListeners = Math.max(0, this.activeListeners - 1);
          return handle.remove();
        },
      }),
      (error) => {
        this.activeListeners = Math.max(0, this.activeListeners - 1);
        throw error;
      },
    );
  }

  /**
   * `App.addListener('backButton', …)`, on its own so a spec can stand in for
   * it: `App` is a Capacitor plugin Proxy whose methods cannot be spied.
   */
  protected addNativeListener(
    listener: () => void,
  ): Promise<PluginListenerHandle> {
    return App.addListener('backButton', listener);
  }
}
